import { Box } from "components/common";
import Navigation from "./navigation";

const DrawerContent = () => (
  <Box
    mt="100px"
    height="calc(100% - 100px)"
    // sx={{
    //   overflowY: "auto",
    //   overflowX: "hidden",
    // }}
  >
    <Navigation />
  </Box>
);

export default DrawerContent;
